import {CheckCircle2, Clock, AlertTriangle, ListTodo} from 'lucide-react'
import type {Task} from '../../types'

interface TasksStatsProps {
  tasks: Task[]
}

export default function TasksStats({tasks}: TasksStatsProps) {
  const total = tasks.length
  const done = tasks.filter((t) => t.status === 'done').length
  const inProgress = tasks.filter((t) => t.status === 'in_progress').length
  const overdue = tasks.filter((t) => {
    if (!t.dueDate || t.status === 'done') return false
    return new Date(t.dueDate) < new Date()
  }).length

  const completionRate = total > 0 ? Math.round((done / total) * 100) : 0

  const stats = [
    {
      label: 'Total de Tarefas',
      value: total,
      icon: ListTodo,
      color: 'bg-slate-50 text-slate-600',
      iconColor: 'text-slate-500',
      borderColor: 'border-slate-200',
    },
    {
      label: 'Em Progresso',
      value: inProgress,
      icon: Clock,
      color: 'bg-blue-50 text-blue-700',
      iconColor: 'text-blue-500',
      borderColor: 'border-blue-200',
    },
    {
      label: 'Concluídas',
      value: `${done} (${completionRate}%)`,
      icon: CheckCircle2,
      color: 'bg-emerald-50 text-emerald-700',
      iconColor: 'text-emerald-500',
      borderColor: 'border-emerald-200',
    },
    {
      label: 'Atrasadas',
      value: overdue,
      icon: AlertTriangle,
      color: 'bg-red-50 text-red-700',
      iconColor: 'text-red-500',
      borderColor: 'border-red-200',
    },
  ]

  return (
    <div className='grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4'>
      {stats.map((stat) => (
        <div
          key={stat.label}
          className={`devops-stat-card ${stat.borderColor} ${stat.color} p-4 transition-all duration-200`}
        >
          <div className='flex items-center justify-between mb-2'>
            <stat.icon size={20} className={stat.iconColor} />
          </div>
          <p className='text-2xl font-bold tracking-tight'>{stat.value}</p>
          <p className='text-xs font-medium opacity-70 mt-0.5'>{stat.label}</p>
        </div>
      ))}
    </div>
  )
}
